var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCsvDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 13.5,
    cy: 15.5,
    r: 5.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#04A0C5",
    fillRule: "nonzero",
    d: "M15.221 6.59V4.108L10.72 0H.04v19h15.181v-2.766z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    cx: 13.5,
    cy: 15.5,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#04A0C5",
    strokeLinejoin: "square",
    cx: 13.5,
    cy: 15.5,
    r: 5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9 11h9v9H9z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04A0C5",
    strokeWidth: 1.125,
    d: "M10.875 15.875l1.837 1.575 3.413-4.2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvDownload);
export default __webpack_public_path__ + "static/media/csv-download.61cfac87622a24023ba7e789268fd2d6.svg";
export { ForwardRef as ReactComponent };